import React, { Component } from 'react';
import { DASHBOARD_SCREEN } from '../../global/Constants';
import { DashboardType } from '../../global/Enum';

class DashboardUsers extends Component {

    componentDidMount() {
        //this.getFilledWidth(45, 44);
        //this.getUnFilledWidth(45, 44);

        //this.getFilledWidth(50, 35);
        //this.getUnFilledWidth(50, 35);
    }

    getActiveUsersPercent() {
        const { userActivity } = this.props;
        let totalUser = userActivity.total_user;
        if (totalUser > 0) {
            let activeUser = userActivity.active_user;
            const percent = (activeUser * 100) / totalUser;
            return Math.round(percent) + "%";
        } else {
            return 0 + "%";
        }
    }

    getWidthMaxValue() {
        const { userActivity } = this.props;
        let maxValue = Math.max.apply(Math, userActivity.user_detail.map(function (user) {
            return user.total_activity;
        }))
        return maxValue;
    }

    getBarWidthValue(total) {
        const totalWidth = (total * 100) / this.getWidthMaxValue();
        return totalWidth;
    }

    getFilledWidth(totalActivity, completedActivity) {
        const width = this.getBarWidthValue(totalActivity);
        const percent = (completedActivity * width) / totalActivity;
        return Math.round(percent) + "%";
    }

    getUnFilledWidth(totalActivity, completedActivity) {
        const width = this.getBarWidthValue(totalActivity);
        const percent = (completedActivity * width) / totalActivity;
        return Math.round(width - percent) + "%";
    }

    render() {
        const { userActivity, activeTab } = this.props;
        if (userActivity) {
            return (
                <div id="users" className={activeTab === DashboardType.USERS ? "more-menu-body" : "d-none"}>
                    <h6 className="font-weight-medium d-flex">{DASHBOARD_SCREEN.ACTIVE_USERS}
                        <span className="ml-auto">{userActivity?.active_user}/{userActivity?.total_user}</span>
                    </h6>
                    <div className="progress progress-red1 mb-3">
                        <div className={`progress-bar ${userActivity?.active_user === 0 ? "progress-padding" : ''} `} role="progressbar" style={{ width: this.getActiveUsersPercent() }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                            {this.getActiveUsersPercent()}
                        </div>
                    </div>

                    <div className="gray-bg bdr-radius-7 p-0 p-md-3">
                        <div className="row">
                            <div className="col-12">
                                <h6 className="font-weight-medium text-white">{DASHBOARD_SCREEN.ACTIVITIES_COMPLETED_PLANNED_USERS}</h6>
                            </div>
                        </div>

                        <div className="row mt-3">
                            {
                                userActivity?.user_detail.length ?
                                    userActivity?.user_detail.map((item, i) => (
                                        item.total_activity > 0 ?
                                            <div className="col-12 mb-3" key={i}>
                                                <div className="row align-items-center">
                                                    <div className="col-4 col-md-3 text-right">
                                                        <label className="mb-0 text-white">{item.user_name}</label>
                                                    </div>
                                                    <div className="col-8 col-md-9 pl-0">
                                                        <div className="progress double-progress-bar">
                                                            <div className={`progress-bar bg-primery ${item?.total_activity === item.completed_activity ? "progress-fill" : ''}`} role="progressbar" style={{ width: this.getFilledWidth(item.total_activity, item.completed_activity) }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">{item.completed_activity}</div>
                                                            <div className="progress-bar bg-white progress-padding" role="progressbar" style={{ width: this.getUnFilledWidth(item.total_activity, item.completed_activity) }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                                                            <span>{item.total_activity}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> : null
                                    )) : null
                            }

                            {/* <div className="col-12 mb-3">
                                <div className="row align-items-center">
                                    <div className="col-5 col-md-3 text-right">
                                        <label className="mb-0 text-white">Suresh Patare123</label>
                                    </div>
                                    <div className="col-7 col-md-9 pl-0">
                                        <div className="progress double-progress-bar">
                                            <div className="progress-bar bg-primery" role="progressbar" style={{ width: "70%" }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">35</div>
                                            <div className="progress-bar bg-white" role="progressbar" style={{ width: "30%" }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">50</div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            {/* <div className="col-12 mb-3">
                                <div className="row align-items-center">
                                    <div className="col-5 col-md-3 text-right">
                                        <label className="mb-0 text-white">Suresh Patare</label>
                                    </div>
                                    <div className="col-7 col-md-9 pl-0">
                                        <div className="progress double-progress-bar">
                                            <div className="progress-bar bg-primery" role="progressbar" style={{ width: "88%" }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">44</div>
                                            <div className="progress-bar bg-white" role="progressbar" style={{ width: "02%" }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">45</div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}


                            {/* <div className="col-12 mb-3">
                                <div className="row align-items-center">
                                    <div className="col-5 col-md-3 text-right">
                                        <label className="mb-0 text-white">Amjat Hussain</label>
                                    </div>
                                    <div className="col-7 col-md-9 pl-0">
                                        <div className="progress double-progress-bar">
                                            <div className="progress-bar bg-primery" role="progressbar" style={{ width: "60%" }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">28</div>
                                            <div className="progress-bar bg-white" role="progressbar" style={{ width: "15%" }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">30</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mb-3">
                                <div className="row align-items-center">
                                    <div className="col-5 col-md-3 text-right">
                                        <label className="mb-0 text-white">Jollu Naveen</label>
                                    </div>
                                    <div className="col-7 col-md-9 pl-0">
                                        <div className="progress double-progress-bar">
                                            <div className="progress-bar bg-primery" role="progressbar" style={{ width: "70%" }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">44</div>
                                            <div className="progress-bar bg-white" role="progressbar" style={{ width: "15%" }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">45</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mb-3">
                                <div className="row align-items-center">
                                    <div className="col-5 col-md-3 text-right">
                                        <label className="mb-0 text-white">Ram Kishan</label>
                                    </div>
                                    <div className="col-7 col-md-9 pl-0">
                                        <div className="progress double-progress-bar">
                                            <div className="progress-bar bg-primery" role="progressbar" style={{ width: "66%" }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">34</div>
                                            <div className="progress-bar bg-white" role="progressbar" style={{ width: "15%" }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">40</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mb-3">
                                <div className="row align-items-center">
                                    <div className="col-5 col-md-3 text-right">
                                        <label className="mb-0 text-white">Ramesh Sant</label>
                                    </div>
                                    <div className="col-7 col-md-9 pl-0">
                                        <div className="progress double-progress-bar">
                                            <div className="progress-bar bg-primery" role="progressbar" style={{ width: "56%" }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">27</div>
                                            <div className="progress-bar bg-white" role="progressbar" style={{ width: "15%" }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">29</div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>

                    </div>

                </div>
            )
        } else {
            return null;
        }


    }
}

export default DashboardUsers;
